import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
export var ServiceTicketNotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(ServiceTicketNotFoundError, _Error);

  var _super = _createSuper(ServiceTicketNotFoundError);

  function ServiceTicketNotFoundError() {
    _classCallCheck(this, ServiceTicketNotFoundError);

    return _super.call(this, 'ServiceTicket not found');
  }

  return ServiceTicketNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWJzL3NlcnZpY2UtdGlja2V0LW5vdC1mb3VuZC1lcnJvci50cyJdLCJuYW1lcyI6WyJTZXJ2aWNlVGlja2V0Tm90Rm91bmRFcnJvciIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7O0FBQUEsV0FBYUEsMEJBQWI7QUFBQTs7QUFBQTs7QUFDRSx3Q0FBYztBQUFBOztBQUFBLDZCQUNOLHlCQURNO0FBRWI7O0FBSEg7QUFBQSxpQ0FBZ0RDLEtBQWhEIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIFNlcnZpY2VUaWNrZXROb3RGb3VuZEVycm9yIGV4dGVuZHMgRXJyb3Ige1xuICBjb25zdHJ1Y3RvcigpIHtcbiAgICBzdXBlcignU2VydmljZVRpY2tldCBub3QgZm91bmQnKTtcbiAgfVxufVxuIl19